import { replace, startsWith } from 'lodash/fp';

// Sanity represents an unpublished document by prefixing its `_id` with `drafts.`.
const DRAFT_ID_PREFIX = 'drafts.';

export const isDraftId = (id?: string | null) => startsWith(DRAFT_ID_PREFIX, id ?? '');

export const removeDraftPrefix = (id?: string | null) => replace(DRAFT_ID_PREFIX, '', id ?? '');

export const isSanityDraft = (document: { _id?: string | null }) => isDraftId(document._id);
